'use strict'

var wh = window.innerHeight

class AnimatedCircles {
  constructor () {
    this.config = {
      circleClass: '.sl__circle'
    }

    this.parseCircles()
    this.scroll()

    window.addEventListener('scroll', () => { this.scroll() })
    window.addEventListener('resize', () => {
      wh = window.innerHeight
      this.parseCircles()
    })
  }

  parseCircles () {
    this.circles = []
    const circles = document.querySelectorAll(this.config.circleClass)

    Array.prototype.forEach.call(circles, (circle) => {
      let object = new AnimatedCircle(circle)
      this.circles.push(object)
    })
  }

  scroll () {
    Array.prototype.forEach.call(this.circles, (circle) => {
      circle.animate()
    })
  }
}

class AnimatedCircle {
  constructor (circle) {
    this.offset = 50
    this.circle = circle
    this.parseElement()
  }

  parseElement () {
    const circle = this.circle
    this.dia = circle.scrollHeight
    this.pt = $(circle).parent().offset().top
    this.ph = circle.parentElement.scrollHeight
    this.pl = $(circle).parent().offset().left
    this.pr = $(window).width() - ($(circle).parent().offset().left + circle.parentElement.offsetWidth)
  }

  animate () {
    const dia = this.dia
    const pt = this.pt
    const ph = this.ph
    const pl = this.pl
    const pr = this.pr
    const offset = this.offset

    var st = window.scrollY
    var sl = window.scrollX
    var ePosition = 'absolute'
    var eLeft = 0
    var eRight = 'auto'
    var eTransform = 'translateX(-50%)'
    var eTop

    if ($(this.circle).parent().hasClass('--right')) {
      eLeft = 'auto'
      eRight = 0
      eTransform = 'translateX(50%)'
    }

    if ((st - pt) > 0 && (st - pt) < (ph - wh)) {
      ePosition = 'fixed'
      eTop = offset + (wh - dia - 2 * offset) * (st - pt) / (ph - wh)
      eLeft = pl - dia / 2 - sl
      eTransform = 'translateX(0)'

      if ($(this.circle).parent().hasClass('--right')) {
        eLeft = 'auto'
        eRight = pr - dia / 2 + sl
      }
    } else if ((st - pt) <= 0) {
      eTop = offset
    } else if ((st - pt) >= (ph - wh)) {
      eTop = ph - dia - offset
    }

    $(this.circle).css({
      'position': ePosition,
      'top': eTop,
      'left': eLeft,
      'right': eRight,
      'transform': eTransform
    })
  }
}

export { AnimatedCircles, AnimatedCircle }
